import React from 'react';
import { connect } from 'dva';

import { framework_tool, utils_tool } from '../../../../tool'
import PropTypes from 'prop-types';
import { SubjectForm } from '../../../../components'
import { modelUtils } from "@/utils";
let { WizContainer, ossFileUtils } = framework_tool;
import QuestionCategorySelect from '../../bankQuestion/questionCategorySelect/questionCategorySelect';
let { checkStrLength, $$, Session, dateUtils } = utils_tool;
import { Spin } from 'antd'
import moment from 'moment';
class BankQuestionDetail extends WizContainer {

  componentName = 'BankQuestionDetail';

  constructor(props) {
    super(props);
    this.initTypeAndRecord();
    this.state = {
      bankId: '',
    };
  }

  /**
   * 初始化时根据record判断是新增还是编辑
   */
  initTypeAndRecord() {
    let record = {};
    let type = 'create';
    let questionId = '';
    if (this.props.location && this.props.location['record'] && this.props.location['record']['id']) {
      record = this.props.location['record']
      type = 'update'
      questionId = record['id']
      Session.set('bankQuestionInfo', record)
    } else {
      let pathname = this.props.location['pathname'];
      record = pathname === '/online/bankQuestion/bankQuestionAdd' ? {} : (Session.get('bankQuestionInfo') || {})
      if (record && record['id']) {
        type = 'update'
        questionId = record['id']
      } else {
        record = {}
      }
    }
    this.ownCactegoryInfo = []
    this.record = record;
    if (record['categoryIds'] && record['categoryNames']) {
      let categoryIds = record['categoryIds'].split(",")
      let categoryNames = record['categoryNames'].split(",")
      let ownCactegoryInfo = []
      for (let i = 0; i < categoryIds.length; i++) {
        ownCactegoryInfo.push({ key: categoryIds[i], title: categoryNames[i], label: categoryNames[i] })
      }
      this.ownCactegoryInfo = ownCactegoryInfo
    }
    this.type = type;
    this.questionId = questionId;
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/online/bankQuestion/bankQuestionUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('bankQuestionInfo', initialValue)
      } else {
        initialValue = Session.get('bankQuestionInfo') || {};
      }
    }
    if(this.questionId != initialValue.id){
      this.questionId = initialValue.id
      this.setState({ bankId: initialValue.id })
      if (initialValue.categoryIds) {
        let categoryIds = initialValue['categoryIds'].split(",")
        let categoryNames = initialValue['categoryNames'].split(",")
        let ownCactegoryInfo = []
        for (let i = 0; i < categoryIds.length; i++) {
          ownCactegoryInfo.push({ key: categoryIds[i], title: categoryNames[i], label: categoryNames[i] })
        }
        this.ownCactegoryInfo = ownCactegoryInfo
      }
      this._componentDidMount(this.questionId)

    }

  }

  _componentDidMount(questionId) {
    if (this.type === 'update') {
      this.doActions([
        {
          path: 'bankQuestion/bankQuestionInfo',
          payload: {
            key: 'bankQuestionInfoKey',
            apiParams: { id: this.questionId}
          }
        },
      ]
      )
    }
  }
  //新增成功返回列表信息页面
  _add(nextProps, nextState) {
    let { add } = nextProps
    if (add && add['success']) {
      wizNotice.success(add['msg'])
      this.jumpPage('replaceAndDelCrumb', '/online/bankQuestion');
      return true
    } else {
      wizNotice.error(add && add['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _bankQuestionInfo(nextProps, nextState) {
    let bankQuestionInfo = nextProps['bankQuestionInfo'];
    if (bankQuestionInfo && bankQuestionInfo['success']) {
      this.bankQuestionInfoData = bankQuestionInfo.data
      this.bankQuestionInfoData.type = this._getValue('types2', this.bankQuestionInfoData.type)
      this.bankQuestionInfoData.code = this.bankQuestionInfoData.number
      this.bankQuestionInfoData.subject = this.bankQuestionInfoData.title
      this.bankQuestionInfoData.order = this.bankQuestionInfoData.order === 1 ? true : false
      this.bankQuestionInfoData.difficulty = this._getValue('difficultys2', this.bankQuestionInfoData.difficulty)
      this.bankQuestionInfoData.isStart = true
      //单选
      if (this.bankQuestionInfoData.type === 'Single') {
        this.bankQuestionInfoData.answer = parseInt(this.bankQuestionInfoData.correct)
        //多选
      } else if (this.bankQuestionInfoData.type === 'Multiple') {
        this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct.split(",").map(p => parseInt(p))
        //判断
      } else if (this.bankQuestionInfoData.type === 'Judgement') {
        this.bankQuestionInfoData.answer = parseInt(this.bankQuestionInfoData.correct)
        //主观
      } else if (this.bankQuestionInfoData.type === 'Subjective') {
        this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct
        //填空
      } else if (this.bankQuestionInfoData.type === 'Completion') {
        let i = 0

        let corrent = JSON.parse(this.bankQuestionInfoData.correct)
        let completionAnswer = {}
        if (corrent instanceof Array) {
          for (i = 0; i < corrent.length; i++) {
            let answer = []
            let keys = []
            let correntTemp = corrent[i]
            if (correntTemp instanceof Array) {
              for (j = 0; j < correntTemp.length; j++) {
                keys.push(j)
              }
              completionAnswer[`answer` + i] = corrent[i]
              completionAnswer[`keys` + i] = keys
            }
          }
          this.bankQuestionInfoData.answerSize = corrent.length
        }
        this.bankQuestionInfoData.answer = completionAnswer
      } else if (this.bankQuestionInfoData.type === 'FileUpload') {
        this.bankQuestionInfoData.answer = !!this.bankQuestionInfoData.correct ? [{ fileId: this.bankQuestionInfoData.correct }] : []
      } else if (this.bankQuestionInfoData.type === 'Sort') {
        this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct.split(",").map(p => parseInt(p)).map(p => String.fromCharCode(p + 65)).join('')
      }
      this.bankQuestionInfoData.analysis = this.bankQuestionInfoData.answerAnalysis
      this.bankQuestionInfoData.choiceFormKey = 1
      this.bankQuestionInfoData.classify = this.bankQuestionInfoData.categoryIds.split(",")
    }
    return true
  }
  propsAndStateOnChange = {
    //新增方法
    add: this._add.bind(this),
    bankQuestionInfo: this._bankQuestionInfo.bind(this),
  }


  /**给数据加key */
  giveKey(data) {
    data.key = data.value;
    if (data.children && data.children instanceof Array) {
      data.children.forEach(children => {
        this.giveKey(children)
      })
    }
  }

  _getValue(type, key) {
    const values = {
      types: {
        Single: 0,
        Multiple: 1,
        Judgement: 2,
        Completion: 3,
        Subjective: 4,
        FileUpload: 6,
        Sort: 7,
      },
      difficultys: {
        low: 0,
        middle: 1,
        high: 2
      },
      types2: {
        0: 'Single',
        1: 'Multiple',
        2: 'Judgement',
        3: 'Completion',
        4: 'Subjective',
        6: 'FileUpload',
        7: 'Sort',
      },
      difficultys2: {
        0: 'low',
        1: 'middle',
        2: 'high'
      },
    }
    return values[type][key]
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      //类型时做逻辑处理
      if (key === 'type') {
        if (value === null || value === undefined || !value[0]) {
          fitterValues['typeTemp'] = 0;
        } else {
          fitterValues['typeTemp'] = this._getValue('types', value);
        }
        //填空题时生产答案信息
        if (fieldsValue['type'] === "Completion") {
          let answerObject = []
          for (let i = 0; ; i++) {
            let answer = ''
            const answerCurrent = 'answer' + i;
            const answerKey = 'keys' + i;
            if (fieldsValue[answerKey] === undefined) {
              break;
            } else {
              answerObject.push(fieldsValue[answerCurrent])
              // answerObject[answerKey] = fieldsValue[answerKey]
              // answerObject[answerCurrent] = fieldsValue[answerCurrent]
            }
            answer = JSON.stringify(answerObject)
            fitterValues['answer'] = answer
          }

        } else {
        }
      } else if (key === 'answer') {
        if (fieldsValue['type'] === "Multiple" && $$.isArray(value)) {
          fitterValues['answer'] = value.sort((a, b) => { return a - b; }).join(',');
        } else if (fieldsValue['type'] === "Single" || fieldsValue['type'] === "Judgement" || fieldsValue['type'] === "Subjective") {
          fitterValues['answer'] = (value || value == 0) ? value : ''
        } else if (fieldsValue['type'] === "Sort") {
          let tmp_answer = ''
          if (value?.length) {
            for (let i = 0; i < value.length; i++) {
              tmp_answer = tmp_answer + (value.charCodeAt(i) - 65)
              if (i < value.length - 1) {
                tmp_answer = tmp_answer + ','
              }
            }
          }
          fitterValues['answer'] = tmp_answer
        } else if (fieldsValue['type'] === "FileUpload") {
          fitterValues['answer'] = value?.length ? value[value.length - 1]?.fileId : ''
        }

      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    fitterValues['type'] = fitterValues['typeTemp']
    fitterValues['difficulty'] = this._getValue('difficultys', fitterValues['difficulty']);
    fitterValues['option'] = fitterValues['options'];
    fitterValues['order'] = fitterValues['order'] === true ? 1 : 0;

    fitterValues['classify'] = fitterValues['classify'].map(p => parseInt(p))
    return fitterValues;
  }
  _render() {

    let { bankQuestionLoading, questionTypeLoading } = this.props
    const dataTableProps = {
      key: this.state.bankId || '',
      title: (this.type === 'create' ? '新增' : '修改') + '题目',
      propInfo: this.bankQuestionInfoData,
      treeSelectList: QuestionCategorySelect,
      selects: this.ownCactegoryInfo,
      submit: (e) => {
        let apiPath = (this.type === 'create' ? 'bankQuestion/add' : 'bankQuestion/upd');
        let fitterValues = this.fitterFieldsValue(e)
        this.doAction({
          path: apiPath,
          payload: {
            key: "addBankQuestionKey",
            apiParams: {
              id: this.questionId,
              ...fitterValues
            }
          }
        });
      },
    };

    return (
      <Spin tip={'加载中'} spinning={bankQuestionLoading && questionTypeLoading && this.bankQuestionInfoData}>
        <SubjectForm {...dataTableProps} />
      </Spin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { bankQuestion } = state;
  const add = modelUtils.getModelEntity(bankQuestion, "addBankQuestionKey");

  const bankQuestionInfo = modelUtils.getModelEntity(bankQuestion, "bankQuestionInfoKey");
  const load = modelUtils.getLoadingState(state, ['bankQuestion']);
  return {
    bankQuestionInfo,
    selects: ownProps.selects,
    add,
    ...load
  }
};

export default connect(mapStateToProps)(BankQuestionDetail);
